// Identificativo del dispositivo (il browser) e descrizione leggibile di un browser dal suo user agent.

const KEY = 'device_id';

const randomId = () => {
  try {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID().replace(/-/g, '');
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  } catch (e) {
    return Math.random().toString(36).slice(2) + Date.now().toString(36) + Math.random().toString(36).slice(2);
  }
};

/**
 * Id di questo browser: lo si crea la prima volta e si conserva. Serve al server per capire che due accessi
 * vengono dallo stesso dispositivo (il secondo sostituisce il primo invece di contare due volte).
 */
export const deviceId = () => {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = randomId();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch (e) {
    return ''; // senza memoria locale il server conta ogni accesso come un dispositivo nuovo
  }
};

// Indirizzi di questo stesso computer (sviluppo in locale): più chiaro di «::1».
export const upperFirst = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export const isLocalIp =(ip) => ['::1', '127.0.0.1', '::ffff:127.0.0.1', 'localhost'].includes(String(ip || '').trim());

const NOTICE_KEY = 'session_notice';

/**
 * Quando il server respinge una richiesta perché l'accesso è stato chiuso, il motivo si conserva qui: la pagina di login
 * lo mostra (takeSessionNotice) subito dopo il reindirizzamento.
 */
export const saveSessionNotice = (data) => {
  try {
    if (data && data.code === 'session_closed') {
      localStorage.setItem(NOTICE_KEY, JSON.stringify({ reason: data.reason, at: data.at, by_ip: data.by_ip, by_agent: data.by_agent }));
    }
  } catch (e) {
    // senza memoria locale si perde solo la spiegazione
  }
};

/** Legge e cancella l'avviso conservato (null se non c'è). */
export const takeSessionNotice = () => {
  try {
    const raw = localStorage.getItem(NOTICE_KEY);
    if (!raw) return null;
    localStorage.removeItem(NOTICE_KEY);
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
};

/** «Chrome · Windows», «Safari · iPhone»… dall'user agent (riconoscimento approssimativo, solo per riconoscere il dispositivo). */
export const describeAgent = (userAgent) => {
  const ua = String(userAgent || '');
  if (!ua) return { browser: '', os: '', mobile: false };
  let browser = '';
  if (/Edg(e|A|iOS)?\//.test(ua)) browser = 'Edge';
  else if (/OPR\/|Opera/.test(ua)) browser = 'Opera';
  else if (/SamsungBrowser/.test(ua)) browser = 'Samsung Internet';
  else if (/Firefox|FxiOS/.test(ua)) browser = 'Firefox';
  else if (/Chrome|CriOS/.test(ua)) browser = 'Chrome';
  else if (/Safari/.test(ua)) browser = 'Safari';
  let os = '';
  if (/iPhone/.test(ua)) os = 'iPhone';
  else if (/iPad/.test(ua)) os = 'iPad';
  else if (/Android/.test(ua)) os = 'Android';
  else if (/Windows/.test(ua)) os = 'Windows';
  else if (/Mac OS X|Macintosh/.test(ua)) os = 'Mac';
  else if (/CrOS/.test(ua)) os = 'ChromeOS';
  else if (/Linux/.test(ua)) os = 'Linux';
  return { browser, os, mobile: /iPhone|iPad|Android|Mobile/.test(ua) };
};

export const agentLabel = (userAgent) => {
  const { browser, os } = describeAgent(userAgent);
  return [browser, os].filter(Boolean).join(' · ');
};
